/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FailureRepairmenDto
 */
export interface FailureRepairmenDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof FailureRepairmenDto
     */
    repairmanIds?: Array<string> | null;
}

export function FailureRepairmenDtoFromJSON(json: any): FailureRepairmenDto {
    return FailureRepairmenDtoFromJSONTyped(json, false);
}

export function FailureRepairmenDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureRepairmenDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'repairmanIds': !exists(json, 'repairmanIds') ? undefined : json['repairmanIds'],
    };
}

export function FailureRepairmenDtoToJSON(value?: FailureRepairmenDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'repairmanIds': value.repairmanIds,
    };
}


